<template>
  <el-form label-width="100px">
    <el-form-item label="意图名称：">
      <el-input
        v-model="questionForm.intent_name"
        placeholder="请输入意图名称"
      ></el-input>
    </el-form-item>
    <el-form-item label="标准问法：">
      <el-input
        v-model="questionForm.question"
        placeholder="请输入标准问法"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    computed: {
      ...mapState({
        questionForm: (state) => state.aimManager.questionForm,
      }),
    },
  }
</script>

<style lang="scss" scoped></style>
